usersModule.factory('usersEditService',
    ['commonRESTCallService', 'userAuthenticateService', 'AppSettings',
    function (commonRESTCallService, userAuthenticateService, AppSettings) {
        var userEditApi = {};
        var token = '';

        userEditApi.createUser = function(user) {
            if(!token)
                token = userAuthenticateService.getUserToken();

            var createUrl = AppSettings.startIdentitySvcURL + 'useraccounts/';

            return commonRESTCallService.postToServerWithToken(createUrl, user.convertForIdentityManagement(), token);
        };

        userEditApi.checkLoginIdAvailability = function(loginIdCandidate) {
            if(!token)
                token = userAuthenticateService.getUserToken();

            var checkLoginIdUrl = AppSettings.startIdentitySvcURL + 'useraccounts/usernameok/' + loginIdCandidate;

            return commonRESTCallService.getFromServerWithToken(checkLoginIdUrl, token);
        };

        userEditApi.updateUser = function(user) {
            if(!token)
                token = userAuthenticateService.getUserToken();

            var updateUrl = AppSettings.startIdentitySvcURL + 'useraccounts/' + user.id;

            return commonRESTCallService.putToServerWithToken(updateUrl, user.convertForIdentityManagement(), token);
        };

        userEditApi.changePassword = function(imUserId, password) {
            // imUserId will normally be the same as the logged in user, but need not be
            if(!token)
                token = userAuthenticateService.getUserToken();
    
            var updateUrl = AppSettings.startIdentitySvcURL + 'useraccounts/' + imUserId + '/passwordchange/';
            var passwordObject = { NewPassword: password} ;
    
            // Todo: Password needs to be encrypted here. Should not be sent in clear text
            return commonRESTCallService.postToServerWithToken(updateUrl, passwordObject, token);
        };

        userEditApi.resetAndEmailPassword = function(resetParameters) {
            var resetAndEmailPasswordUrl = AppSettings.startIdentitySvcURL + 'userauthentications/passwordreset/';
            return commonRESTCallService.postToServer(resetAndEmailPasswordUrl, resetParameters);
        };

        return userEditApi;
    }
]);